import "./HomePage.css";

import React from "react";
import Dropzone from "react-dropzone";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import Header from "../app/Header";
import Sidebar from "../app/Sidebar";

import { Container, Row, Col } from "reactstrap";

class HomePage extends React.Component {
  constructor() {
    super();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    return (
      <div className="home-page">
        <Helmet title={"Dashboard"} />
        <Header title="Dashboard" />

        <div className="page">
          <div className="sidebar-wrapper">
            <Sidebar />
          </div>

          <div className="content">
            <Container>
              <Row>
                <Col xs="12">
                  <img
                    style={{
                      marginTop: "50px",
                      width: "600px",
                      marginLeft: "100px"
                    }}
                    src="https://orig10.deviantart.net/a9a9/f/2013/228/4/d/cat_cute_rolling_png_by_princessbubblegum5-d6igiqf.png"
                  />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    );
  }
}

HomePage.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(state => ({}), {})(HomePage);



// WEBPACK FOOTER //
// ./src/browser/home/HomePage.js